import { useQuery } from '@cbgms/base/http/use-query'
import { isEmptyUUID } from '@cbgms/base/utils/uuid'
import { getThemeByUUID } from 'app/auth/state/actions'
import { useDispatch } from 'react-redux'

export const ONBOARDING_CACHE_KEY = 'ONBOARDING'
export const THEME_CACHE_KEY = 'THEME'

const getThemeCacheKey = (uuid: string) => [ONBOARDING_CACHE_KEY, THEME_CACHE_KEY, uuid]

export const useGetOnboardingTheme = (uuid: string) => {
  const dispatch = useDispatch()
  const result = useQuery(getThemeCacheKey(uuid), async () => {
    if (isEmptyUUID(uuid)) {
      return null
    }
    return dispatch(getThemeByUUID(uuid))
  })

  return result
}
